var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._b({staticClass:"textarea",domProps:{"value":_vm.value},on:{"input":_vm.emitEvent}},'textarea',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }